import React, { useEffect } from 'react'
import { track } from '@utils/tracking'
import styles from './loadError.module.sass'

// The data didn't load. Often a blip, so this offers a retry and keeps the
// saved choice; the switch above takes people back if it keeps failing.
export const LoadError = ({ onRetry }: { onRetry: () => void }) => {
  useEffect(() => {
    track('FFP Dashboard: Load failed')
  }, [])

  return (
    <div className={`ffpDashboard ${styles.loadError}`} role="alert">
      <h2 className={styles.title}>We couldn't load the new dashboard</h2>
      <p className={styles.body}>
        Try again in a moment, or switch off “Try new dashboard experience” to go back to the current one.
      </p>
      <button type="button" className={styles.retry} onClick={onRetry}>
        Try again
      </button>
    </div>
  )
}
